import React from 'react';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import classNames from 'classnames';
import { IParentComponent } from '../interfaces/IParentComponent';

export const HeaderTextTW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-xl', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'header-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'header-tw')}
      {...rest}
    >
      {children}
    </div>
  );
};

export const HeaderText2TW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-2xl', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'header-2-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'header-2-tw')}
    >
      {children}
    </div>
  );
};

export const HeaderText3TW: React.FC<IParentComponent<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <div
      className={classNames('text-3xl', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'header-3-tw')}
      data-test-class={mergeTests(rest['data-test-class'], 'header-3-tw')}
      {...rest}
    >
      {children}
    </div>
  );
};
